<tui-select tuiTextfieldSize="s" [(ngModel)]="selectedLanguage" (ngModelChange)="selectLanguage($event)">
  <tui-data-list-wrapper *tuiDataList [items]="languageCodes"></tui-data-list-wrapper>
</tui-select>
